<app-gallery-settings-customize-header
  title="Image Sizes"
  location="download-sizes-setting-item"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<app-gallery-settings-group [title]="'Choose Sizes'" location="download-sizes-setting-customize">
  <app-access-item icon="/assets/icons/image-sizes.svg" iconColor="grey">
    <app-access-item-header> Small </app-access-item-header>
    <app-access-item-body> Resized to 960px </app-access-item-body>

    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="download-size-small"
          [(ngModel)]="small"
          (ngModelChange)="updateSizes()"
          [disabled]="small() && disableLast()"
        />
        <label for="download-size-small" data-test-id="download-size-small"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>

  <app-access-item icon="/assets/icons/image-sizes.svg" iconColor="grey">
    <app-access-item-header> Medium </app-access-item-header>
    <app-access-item-body> Resized to 1920px </app-access-item-body>

    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="download-size-medium"
          [(ngModel)]="medium"
          (ngModelChange)="updateSizes()"
          [disabled]="medium() && disableLast()"
        />
        <label for="download-size-medium" data-test-id="download-size-medium"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>

  <app-access-item icon="/assets/icons/image-sizes.svg" iconColor="grey">
    <app-access-item-header> Large </app-access-item-header>
    <app-access-item-body> Resized to 3840px </app-access-item-body>

    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="download-size-large"
          [(ngModel)]="large"
          (ngModelChange)="updateSizes()"
          [disabled]="large() && disableLast()"
        />
        <label for="download-size-large" data-test-id="download-size-large"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>

  <app-access-item icon="/assets/icons/image-stack.svg" iconColor="grey">
    <app-access-item-header> Original </app-access-item-header>
    <app-access-item-body> Source file </app-access-item-body>

    <app-access-item-cta>
      <app-switch [smallish]="true">
        <input
          type="checkbox"
          id="download-size-original"
          [(ngModel)]="original"
          (ngModelChange)="updateSizes()"
          [disabled]="original() && disableLast()"
        />
        <label for="download-size-original" data-test-id="download-size-original"></label>
      </app-switch>
    </app-access-item-cta>
  </app-access-item>
</app-gallery-settings-group>
